import $ from 'jquery';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { updateTextOnly } from '@/js/modules/update_text_only';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if (
      $('body').is('#library') ||
      $('body').is('#add-shoppables-to-billables-from-project') ||
      $('body').is('#add-shoppables-to-billables-from-library')
    ) {
      const checkboxSelector = '.checkbox--persist-on-page-reload';
      const toggleAllSelector = '.checkbox--toggle-all-items';

      /**
       * parse url and get ids
       * @return {Set<Integer>} - Set of integer ids
       */
      function getItemIds() {
        const params = queryString();
        let ids = (params['ids'] || '').split(',');
        if (ids[0] === '' && ids.length === 1) {
          ids = [];
        }
        return new Set(ids);
      }

      /**
       * sets given ids into url
       * @param {Set/Array<Integer>} ids - Set or arrays of ids(integer)
       */
      function setItemIds(ids) {
        const params = queryString();
        let url = null;
        params['ids'] = Array.from(ids).join(',');

        if (Object.keys(params).length > 0 && $.param(params).length > 0) {
          url = '?' + $.param(params);
        } else {
          url = window.location.pathname;
        }

        window.history.replaceState(null, '', url);
      }

      function updateHeaderControls(ids) {
        updateHeadCheckbox();
        updateGridButton(ids);
      }

      function updateActionDropdownItems({ enabled }) {
        const $actionItems = $('.dropdown-button--library-action .dropdown-button__item');
        $actionItems.attr('tabindex', enabled ? '0' : '-1');
        $actionItems.attr('aria-disabled', (!enabled).toString());

        if (!enabled) {
          $('.dropdown-button--library-action').removeClass('dropdown-button--active');
        }
      }

      function updateActionButton(ids) {
        const selectedItemsNum = (ids || getItemIds()).size;
        $('.dropdown-button--library-action .dropdown-button__counter').text('');
        $('.dropdown-button--library-action').addClass('dropdown-button--disabled');
        updateActionDropdownItems({ enabled: false });
        $('.p-button--billable-add-shoppables').prop('disabled', true);
        $('.billable-shoppable-selected-count').text('');
        $('.billable-shoppable-clear-selection').hide();
        if (selectedItemsNum > 0) {
          $('.dropdown-button--library-action .dropdown-button__counter').text(
            `(${selectedItemsNum})`
          );
          $('.dropdown-button--library-action').removeClass('dropdown-button--disabled');
          updateActionDropdownItems({ enabled: true });
          $('.p-button--billable-add-shoppables').prop('disabled', false);
          $('.billable-shoppable-selected-count').text(selectedItemsNum);
          $('.billable-shoppable-clear-selection').show();
        }
      }

      function updateDeleteButton() {
        // If all selected items are archived, disable Delete button
        const $deleteActionButton = $('.dropdown-button__item--delete');
        $deleteActionButton.removeClass('dropdown-button__item--disabled df-tooltip');
        $deleteActionButton.find('.df-tooltip__text').remove();
        if ($deleteActionButton.attr('href') === '#modal--delete-confirmation--library-item') {
          $deleteActionButton.attr('rel', 'modal:open');
        } else {
          $deleteActionButton.attr('rel', 'modal:ajax-open');
        }
      }

      // Updates Grid button link according to the ids
      function updateGridButton() {
        const params = queryString();
        $('.library-view-mode__buttons a').each((index, link) => {
          const url = new URL(link.href);
          const localParams = parseQuery(url.search);
          params['library_view_mode'] = localParams['library_view_mode'];
          url.search = '?' + $.param(params);
          link.href = url.href;
        });
      }

      /**
       * Check if checkbox on the table head needs to be checked or not
       * if all the item in the table is selected, then also select
       * checkbox on the table head
       */
      function updateHeadCheckbox() {
        const isAllChecked = $(`${checkboxSelector}:not(:checked)`).length === 0;
        const isThereAnyCheckbox = $(checkboxSelector).length > 0;
        $(toggleAllSelector).prop('checked', isAllChecked && isThereAnyCheckbox);
      }

      /**
       * populate all checkboxes and delete button according to
       * search params in the URL
       */
      function populateItems() {
        const ids = getItemIds();

        $(checkboxSelector).prop('checked', false);
        ids.forEach(function (index, id) {
          $(`${checkboxSelector}[value=${id}]`).prop('checked', true);
        });

        updateHeaderControls(ids);
      }

      function anyItemsInUse() {
        const items = document.querySelectorAll(`${checkboxSelector}:checked`);
        for (const item of items) {
          if (item.dataset['inUse'] === 'true') {
            return true;
          }
        }
        return false;
      }

      populateItems();
      updateActionButton();

      // On check box clicked
      $(document).on('change', checkboxSelector, function (e) {
        if ($(e.target).hasClass('checkbox--library')) {
          checkboxClickedInArchiveList();
        } else {
          const ids = getItemIds();
          const id = $(this).val();
          if ($(this).is(':checked')) {
            ids.add(id);
          } else {
            ids.delete(id);
          }
          const newIds = Array.from(ids).join(',');

          if (ids.size > 0) {
            $('.pagination a').each(function (index, link) {
              const url = new URL(link.href);
              const params = parseQuery(url.search);
              params['ids'] = newIds;
              url.search = '?' + $.param(params);
              link.href = url.href;
            });
          }

          setItemIds(ids);
          updateHeaderControls(ids);
          updateActionButton(ids);
        }
      });

      // On check box on table head clicked
      $(document).on('click', toggleAllSelector, function (e) {
        const checkState = $(this).is(':checked');
        $($(this).closest('table'))
          .find(checkboxSelector)
          .prop('checked', checkState)
          .trigger('change');
      });

      // On checkbox clicked in archive list
      function checkboxClickedInArchiveList() {
        const ids = getItemIds();
        const archiveItemIds = $('.library-table--archive-item')
          .find('.checkbox--library:checked')
          .map(function () {
            return $(this).val();
          })
          .get();
        const inUsedItemIds = $('.library-table--archive-item')
          .find('.checkbox--library')
          .map(function () {
            return $(this).val();
          })
          .get();
        const itemList = new Set(inUsedItemIds);
        const itemToDelete = [...ids].filter((itemId) => !itemList.has(itemId));
        const $deleteButton = $('.d-button--delete-or-archive-item');
        const $deleteButtonIcon = $deleteButton.find('i');
        const defaultIconStyle = $deleteButtonIcon.get(0).classList[0];
        let buttonText = '';
        let itemCountText = '#';
        let deleteText = '';
        let archiveText = '';
        let andText = '';
        let deleteButtonIcon = '';
        if (archiveItemIds.length > 0) {
          archiveText = 'Archive';
          deleteButtonIcon = 'fa-archive';
        }
        if (itemToDelete.length > 0) {
          deleteText = 'Delete';
          deleteButtonIcon = 'fa-trash';
        }
        if (itemToDelete.length > 0 && archiveItemIds.length > 0) {
          andText = ' & ';
        }
        if (itemToDelete.length + archiveItemIds.length > 0) {
          itemCountText = itemToDelete.length + archiveItemIds.length;
          buttonText = `${deleteText}${andText}${archiveText} ${itemCountText} Product(s)`;
          $deleteButton.attr('href', `/items?ids=${archiveItemIds.concat(itemToDelete).join(',')}`);
          $deleteButtonIcon.removeClass().addClass(`${defaultIconStyle} ${deleteButtonIcon}`);
          $deleteButton.removeClass('hide');
        } else {
          buttonText = 'Archive # Product(s)';
          $deleteButton.addClass('hide');
        }
        updateTextOnly($deleteButton, buttonText);
      }

      function initTearsheet() {
        $('.dropdown-button__item--download').attr(
          'href',
          `/items/${Array.from(getItemIds()).join(',')}/xhr_item_tearsheet`
        );
      }

      function initArchiveList() {
        const $deleteActionButton = $('.dropdown-button__item--delete');
        if (anyItemsInUse() === true) {
          const ids = Array.from(getItemIds()).join(',');
          $deleteActionButton.attr('href', `/items/${ids}/xhr_archive_item_list`);
        } else {
          $deleteActionButton.attr('href', '#modal--delete-confirmation--library-item');
        }
      }

      function initDelete() {
        let deleteUrl;
        const headerText = 'Are you completely sure you want to delete these product(s)?';
        const buttonText = 'Yes, Remove Product(s)';
        if ($(this).is('.js-show-library-item-delete-confirmation')) {
          deleteUrl = $(this).data().deleteUrl;
        }

        $('#modal--delete-confirmation--library-item').modal();
        $('#modal--delete-confirmation--library-item .modal__header').text(headerText);
        updateTextOnly(
          $('#modal--delete-confirmation--library-item .d-button--confirm-delete'),
          buttonText
        );
        $('#modal--delete-confirmation--library-item .d-button--confirm-delete').attr(
          'href',
          deleteUrl
        );

        return false;
      }

      function clearSelections() {
        $(checkboxSelector).prop('checked', false).change();
        $('.pagination a').each(function (_, link) {
          const url = new URL(link.href);
          const params = parseQuery(url.search);
          params['ids'] = null;
          url.search = `?${$.param(params)}`;
          link.href = url.href;
        });
        setItemIds([]);
        updateActionButton([]);
      }

      // on delete button clicked
      $(document).on(
        'click',
        '.js-show-library-item-delete-confirmation, .js-show-library-item-delete-confirmation',
        initDelete
      );

      // Bulk Delete clicked
      $(document).on('click', '.dropdown-button__item--delete', (e) => {
        if (anyItemsInUse() === false) {
          initDelete();
        }
      });

      $(document).on('click', '.dropdown-button__label--library-action', function () {
        const $currentDropdown = $(this).closest('.dropdown-button');
        const isDisabled = $currentDropdown.hasClass('dropdown-button--disabled');
        if (isDisabled) {
          $currentDropdown.removeClass('dropdown-button--active');
        } else {
          initTearsheet();
          initArchiveList();
          updateDeleteButton();
        }
      });
      $(document).on('submit', '.modal--tearsheet__form', () => $.modal.close());

      // remove old modal to allow checkboxes to work correctly (eliminate elements with duplicate ids)
      $(document).on($.modal.BEFORE_OPEN, '.modal--tearsheet', () =>
        $('.modal--tearsheet').remove()
      );

      $(document).on('ajax:success', '.dropdown-button__item--archive', (e, data) => {
        $(e.target).parents('.library-item').replaceWith(data);
      });

      $('.dropdown-button__item--clear-selections').click(clearSelections);
      $('.billable-shoppable-clear-selection').click(clearSelections);
    }

    // always leave one checkbox checked in projects dropdown
    $(document).on('click', '.checkbox__label--projects-dropdown', (e) => {
      const checkedBoxes = $('.projects-dropdown__dropdown .checkbox:checked').length;
      if (checkedBoxes === 1 && $(e.currentTarget).prev('.checkbox').is(':checked')) {
        return false;
      }
    });
  });

  document.addEventListener('items--image-fields:primary-changed', ({ detail }) => {
    document
      .querySelectorAll(`.library-item__grid[data-item-id="${detail.itemId}"] .library-grid__image`)
      .forEach((image) => {
        image.src = detail.primaryImageUrl;
      });
  });
});
